import { SimpleCollectionResponse } from "baaanggg";
import { resolveImageUrl } from "@helpers/image.helper";

type Props = {
    collection: SimpleCollectionResponse,
    isSelected: boolean
}

export function CollectionDropdownItem({ collection, isSelected }: Props) {
    return <span className="flex items-center space-x-3">
        <img src={resolveImageUrl(collection.thumbUrl ?? "/src/img/logo/transparant_logo.png")} className="h-8 w-8 rounded-full" loading="lazy"
            alt="avatar" />
        <span className={`${isSelected ? 'text-jacarta-500' : 'text-white'}`}>{collection.name}</span>
    </span>
}